export const worldData = [
    {
        "name": "Spain",
        "value": 3,
        "organizations": [
          /* {
          "location": "Valencia, Spain",
          "name": "John Prior",
          "Organization": "Hospital and University of Lausanne",
          "website": "https://www.lausanneuniversityhospital.com/home",
          "logoscr": require('@/assets/group-logo-CHUV-hachure-black.svg')
        },*/
          
        {
          "location": "Valencia, Spain",
          "name": "Jose Maria Benlloch",
          "Organization": "i3M (CSIC-UPV)",
          "website": "https://www.i3m.upv.es/",
          "logoscr": require('@/assets/logo-web-i3m.png')
        }, 
        {
          "location": "Valencia, Spain",
          "name": "Gabriela Llosa",
          "Organization": "IFIC (CSIC-UVEG)",
          "website": "https://webific.ific.uv.es/web/sobreelific",
          "logoscr": require('@/assets/ific_logo.png')
        }
        ]
      },
      {
        "name": "Chile",
        "value": 1,
        "organizations": [
          {
            "location": "Santiago de Chile, Chile",
            "name": "Horacio Amaral",
            "Organization": "PositronMed",
            "website": "https://cl.linkedin.com/in/horacio-amaral-58a14a72",
            "logoscr": require('@/assets/logo-falp.svg')
          }
        ]
      },
      {

        "name": "United States",
        "value": 9,
        "organizations": [
           {
            "location": "Charlottesville, Virginia, USA",
            "name": "Stan Majewski",
            "Organization": "University of California Davis",
            "website": "https://www.ucdavis.edu/",
            "logoscr": ""
          },
          {
            "location": "Davis, California, USA",
            "name": "Junwei Du",
            "Organization": "University of California, Davis",
            "website": "https://www.ucdavis.edu/",
            "logoscr": ""
          },
          {
            "location": "Davis, California, USA",
            "name": "Simon Cherry",
            "Organization": "University of California, Davis",
            "website": "https://www.ucdavis.edu/",
            "logoscr": require("@/assets/uc-logo-gold.svg")
          },          
         
          {
            "location": "New Haven, Connecticut, USA",
            "name": "Georges El Fakhri",
            "Organization": "Yale University",
            "website": "https://www.yale.edu/",
            "logoscr": require("@/assets/logo-print.png")
          },
          {
            "location": "Stanford, California, USA",
            "name": "Craig Levin",
            "Organization": "Rad/Molecular Imaging Program at Stanford",
            "website": "https://med.stanford.edu/mips.html",
            "logoscr": require("@/assets/logo_uid_stanfordmedicine.svg")
          },
          {
            "location": "San Francisco, USA",
            "name": "Youngho Seo",
            "Organization": "University of California, San Francisco",
            "website": "https://www.ucsf.edu/",
            "logoscr": require("@/assets/ucsf_logo.svg")
          },

          {
            "location": "Boston, Massachusetts, USA",
            "name": "Hamid Sabet",
            "Organization": "Massachusetts General Hospital",
            "website": "https://www.massgeneral.org/",
            "logoscr": require("@/assets/mgh-logo-rgb.svg")
          },
          {
            "location": "New York City, New York, USA",
            "name": "Sadek Nehmeh",
            "Organization": "Weill Cornell Medical College",
            "website": "https://weill.cornell.edu/",
            "logoscr": require("@/assets/wcm_2line_cobrand_rgb.png")
          },

          {
            "location": "West Virginia, USA",
            "name": "Julie Brefczynski",
            "Organization": "Rockefeller Neuroscience Institute",
            "website": "https://rni.wvumedicine.org/",
            "logoscr": require("@/assets/RNI-Logo.jpg")
          },
          {
            "location": "Austin, Texas, USA",
            "name": "Karol Lang",
            "Organization": "University of Texas in Austin",
            "website": "https://www.utexas.edu/",
            "logoscr": require("@/assets/texasAustin.svg")
          }
        ]
      },
      {
        "name": "China",
        "value": 1,
        "organizations": [
          {
            "location": "Shenzhen, China",
            "name": "Qiyu Peng",
            "Organization": "Shenzhen Bay Laboratory",
            "website": "http://pengqy-lab-cn.szbl.ac.cn/",
            "logoscr": ""
          },{
            "location": "Shenzhen, China",
            "name": "Siwei Xie",
            "Organization": "Shenzhen Bay Laboratory",
            "website": "http://pengqy-lab-cn.szbl.ac.cn/",
            "logoscr": require("@/assets/szbl.png")
          }
        ]
      },
      {
        name: "Korea",
        value: 1,
        organizations: [
          {
            Organization: "Korea Institute of Science and Technology",
            name: "Jae Sung Lee",
            location: "Seoul, South Korea",
            website: "https://www.kist.re.kr/",
            logoscr: require("@/assets/img_head_logo.png")

          }
        ]
      },
      {
        "name": "Canada",
        "value": 1,
        "organizations": [
          {
            "location": "Sherbrooke, Quebec, Canada",
            "name": "Roger Lecomte",
            "Organization": "Sherbrooke Molecular Imaging Center",
            "website": "https://www.usherbrooke.ca/recherche/fr/",
            "logoscr": require("@/assets/UDS.png")
          }
        ]
      },
      {
        "name": "Germany",
        "value": 1,
        "organizations": [
          {
            "location": "Aachen, Germany",
            "name": "Volkmar Schulz",
            "Organization": "RWTH University Aachen",
            "website": "https://www.rwth-aachen.de/go/id/a/?lidx=1",
            "logoscr":  require('@/assets/rwth.png')
          }
        ]
      },
      {
        "name": "Japan",
        "value": 1,
        "organizations": [
          {
            "location": "Chiba, Japan",
            "name": "Taiga Yamaya",
            "Organization": "National Institute of Radiological Sciences",
            "website": "https://www.qst.go.jp",
            "logoscr": require('@/assets/sitename.png')
          }
        ]
      },

      {
        "name": "Switzerland",
        "value": 1,
        "organizations": [
          
          {
            "location": "Lausanne, Switzerland",
            "name": "John Prior",
            "Organization": "Hospital and University of Lausanne",
            "website": "https://www.lausanneuniversityhospital.com/home",
            "logoscr": require('@/assets/group-logo-CHUV-hachure-black.svg')
          },
{
          "location": "Geneva, Switzerland",
          "name": "Paul Lecoq",
          "Organization": "European Organization for Nuclear Research",
          "website": "https://home.cern/",
          "logoscr": require('@/assets/cern-logo.png')
        },
        ]
      },
      {
        "name": "Slovenia",
        "value": 1,
        "organizations": [
          {
            "location": "Ljubljana, Slovenia",
            "name": "Rok Pestotnik",
            "Organization": "Jožef Stefan Institute",
            "website": "https://www.ijs.si/ijsw/V001/JSI",
            "logoscr": require('@/assets/jsi.png')
          }
        ]
      },
      {
        "name": "Netherlands",
        "value": 1,
        "organizations": [
          {
            "location": "Groningen, Netherlands",
            "name": "Charalampos Tsoumpas",
            "Organization": "University of Groningen",
            "website": "https://www.rug.nl/?lang=en",
            "logoscr": require('@/assets/logo--en.svg')
          }
        ]
      },
      {
        "name": "Belgium",
        "value": 1,
        "organizations": [
          {
            "location": "Ghent, Belgium",
            "name": "Stefaan Vandenberghe",
            "Organization": "Ghent University",
            "website": "https://www.ugent.be/en",
            "logoscr": require('@/assets/logo_ugent_en.svg')
          }
        ]
      },
      {
        "name": "Poland",
        "value": 2,
        "organizations": [
          
          {
            "location": "Cracow, Poland",
            "name": "Ewa Stępień",
            "Organization": "Jagiellonian University",
            "website": "https://www.uj.edu.pl/en_GB/start",
            "logoscr": require('@/assets/uj-en.svg')
          },
          {
            "location": "Cracow, Poland",
            "name": "Paweł Moskal",
            "Organization": "Jagiellonian University",
            "website": "https://www.uj.edu.pl/en_GB/start",
            "logoscr": require('@/assets/uj-en.svg')
          },
        ]
      },
      {
        "name": "Austria",
        "value": 1,
        "organizations": [
          {
            "location": "Vienna, Austria",
            "name": "Thomas Beyer",
            "Organization": "QIMP Team, Medical University Vienna",
            "website": "",
            "logoscr": require('@/assets/logo-meduni-vienna-cmpbe.png'),
            "logoMaxWidth": 320
          }
        ]
      },
]


// WEBPACK FOOTER //
// ./src/assets/data/worldData.js